import { Button } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';
import classnames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router';
import styles from './link.module.scss';

interface ButtonProps extends AntdButtonProps {
  className?: string;
  path?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

function MenuLink({
  children,
  className,
  path,
  onClick,
  ...props
}: ButtonProps) {
  const navigate = useNavigate();

  function handleOnClick() {
    if (path) {
      navigate(path);
    }
  }

  return (
    <Button
      type="link"
      onClick={onClick || handleOnClick}
      className={classnames(className, styles.menuLink)}
      {...props}
    >
      {children}
    </Button>
  );
}

export default MenuLink;
